import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type SocialEmbedProvider = 'instagram' | 'tiktok';

export type SocialEmbedPlacement = 'content_block' | 'embed_module';

export type SocialEmbedTargetProperties = {
  embed_url: string;
  module_position?: number;
  module_type?: 'embed';
  placement: SocialEmbedPlacement;
  provider: SocialEmbedProvider;
};

type EventData = {
  embedUrl: string;
  guestId?: string;
  isBot: boolean;
  modulePosition?: number;
  moduleType?: 'embed';
  placement: SocialEmbedPlacement;
  provider: SocialEmbedProvider;
};

class SocialEmbedInteractionEvent extends InteractionEvent<
  EventData,
  SocialEmbedTargetProperties
> {
  protected get keepalive(): boolean {
    return true;
  }

  protected get targetType(): InteractionTargetType {
    return 'social_embed';
  }

  protected getTargetProperties(): SocialEmbedTargetProperties {
    return {
      embed_url: this.data.embedUrl,
      module_position: this.data.modulePosition,
      module_type: this.data.moduleType,
      placement: this.data.placement,
      provider: this.data.provider
    };
  }
}

export default SocialEmbedInteractionEvent;
